module.exports = __webpack_public_path__ + "img/pexels-chan-walrus-1059943.f1fddf9d.jpg";